// =============================================================================
//  SCREEN: TrophyScreen (Pokalspenden-Verwaltung)
// =============================================================================
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import apiClient from '../api';
import { toast } from 'react-toastify';

const TrophyScreen = () => {
  const { id: tournamentId } = useParams();
  const [tournament, setTournament] = useState(null);
  const [loading, setLoading] = useState(true);
  const [donations, setDonations] = useState([]);
  
  const [newDonation, setNewDonation] = useState({
    title: '', name: '', contactPerson: '', email: '', notes: '', received: false
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data } = await apiClient.get(`/api/tournaments/${tournamentId}`);
        setTournament(data);
        setDonations(data.trophyDonations || []);
      } catch (err) {
        toast.error('Fehler beim Laden der Daten.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [tournamentId]);

  const handleInputChange = (index, field, value) => {
    const updatedDonations = [...donations];
    updatedDonations[index][field] = value;
    setDonations(updatedDonations);
  };

  const handleNewDonationChange = (e) => {
    const { name, value } = e.target;
    setNewDonation(prev => ({ ...prev, [name]: value }));
  };

  const handleAddDonation = (e) => {
    e.preventDefault();
    if (!newDonation.name) {
      return toast.error("Der Name des Spenders ist ein Pflichtfeld.");
    }
    setDonations([...donations, { ...newDonation, _id: `temp-${Date.now()}` }]);
    setNewDonation({ title: '', name: '', contactPerson: '', email: '', notes: '', received: false });
  };
  
  const handleRemoveDonation = (idToRemove) => {
      setDonations(donations.filter(d => d._id !== idToRemove));
  };

  const handleSave = async () => {
    try {
      // Temporäre IDs für den Speicher-Vorgang entfernen
      const donationsToSave = donations.map(({ _id, ...rest }) => {
        return _id.toString().startsWith('temp-') ? rest : { _id, ...rest };
      });

      // Sende die aktualisierten Daten an das Backend
      const { data: updatedTournament } = await apiClient.put(`/api/tournaments/${tournamentId}`, { 
        ...tournament, // Sende alle Turnierdaten mit, um nichts zu überschreiben
        trophyDonations: donationsToSave 
      });

      // KORREKTUR: Aktualisiere den GESAMTEN Turnier-State und die Spenden-Liste
      setTournament(updatedTournament);
      setDonations(updatedTournament.trophyDonations || []);

      toast.success('Pokalspenden erfolgreich gespeichert!');
    } catch (err) {
      toast.error('Fehler beim Speichern.');
    }
  };

  if (loading) return <p>Lade Pokalspenden...</p>;
  if (!tournament) return <p className="error-message">Turnier nicht gefunden.</p>;

  const receivedCount = donations.filter(d => d.received).length;
  const totalCount = donations.length;

  return (
    <div className="screen-container">
      <div className="page-header-with-action">
        <h2>Pokalspenden für {tournament.name}</h2>
        <button onClick={handleSave} className="btn-primary-action">Änderungen speichern</button>
      </div>

      <div className="summary-box">
        <div className="summary-item">
          <span className="summary-value">{totalCount}</span>
          <span className="summary-label">Pokalzusagen</span>
        </div>
        <div className="summary-item">
          <span className="summary-value">{receivedCount}</span>
          <span className="summary-label">Pokale erhalten</span>
        </div>
      </div>
      
      <div className="form-container-box">
        <h4>Neue Pokalspende hinzufügen</h4>
        <form onSubmit={handleAddDonation} className="trophy-form">
          <input name="title" value={newDonation.title} onChange={handleNewDonationChange} placeholder="Funktion (z.B. Bürgermeister)" />
          <input name="name" value={newDonation.name} onChange={handleNewDonationChange} placeholder="Name (Pflichtfeld)" />
          <input name="contactPerson" value={newDonation.contactPerson} onChange={handleNewDonationChange} placeholder="Kontaktperson" />
          <input name="email" value={newDonation.email} onChange={handleNewDonationChange} placeholder="E-Mail" />
          <input name="notes" value={newDonation.notes} onChange={handleNewDonationChange} placeholder="Anmerkung" />
          <button type="submit">+ Hinzufügen</button>
        </form>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Funktion</th>
              <th>Name</th>
              <th>Kontaktperson</th>
              <th>E-Mail</th>
              <th>Anmerkung</th>
              <th>Erhalten?</th>
              <th>Aktion</th>
            </tr>
          </thead>
          <tbody>
            {donations.map((donation, index) => (
              <tr key={donation._id || index}>
                <td><input type="text" value={donation.title} onChange={(e) => handleInputChange(index, 'title', e.target.value)} /></td>
                <td><input type="text" value={donation.name} onChange={(e) => handleInputChange(index, 'name', e.target.value)} /></td>
                <td><input type="text" value={donation.contactPerson} onChange={(e) => handleInputChange(index, 'contactPerson', e.target.value)} /></td>
                <td><input type="text" value={donation.email} onChange={(e) => handleInputChange(index, 'email', e.target.value)} /></td>
                <td><input type="text" value={donation.notes} onChange={(e) => handleInputChange(index, 'notes', e.target.value)} /></td>
                <td style={{ textAlign: 'center' }}><input type="checkbox" checked={donation.received} onChange={(e) => handleInputChange(index, 'received', e.target.checked)} /></td>
                <td><button onClick={() => handleRemoveDonation(donation._id)} className="btn-delete-small">X</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TrophyScreen;